'use client';
import PaginatorItemDots from './Paginator.ItemDots';
import { usePaginator } from './PaginatorContext';
import { ChevronLeft } from '@icons';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function PaginatorItemBack({ children = null, className = '' }) {
  const { setIndex, index, setScrollDirection } = usePaginator();
  const { dictionary } = useDictionary();

  const handleClick = () => {
    setScrollDirection('backward');
    if (index === 0) return;
    setIndex(index - 1);
  };
  return (
    <PaginatorItemDots
      handleClick={handleClick}
      excludeFromIndexes={true}
      label={dictionary?.archive?.previous || 'Forrige'}
      disabled={index === 0}
      className={`Paginator__item__back ${index === 0 ? 'Paginator__item__back-inactive' : ''} ${className}`}
    >
      {children ? children : <ChevronLeft />}
    </PaginatorItemDots>
  );
}
